export const isObjEmpty = (obj) => Object.keys(obj).length === 0

const defaultLocale = 'en-US';

export const NUMBER_FORMAT_OPTIONS = {
  minimumFractionDigits: 0,
  maximumFractionDigits: 4
};

export const FormatNumber = (value, options = NUMBER_FORMAT_OPTIONS, defaultLocale_ = defaultLocale) => {
  if (value === null || value === undefined) return '';
  if (typeof value === 'number') {
    return value.toLocaleString(defaultLocale_, { options })
  } else if (typeof value === 'string' && !isNaN(value)) {
    value = value.replace(/,/g, ''); // Remove commas for parsing
    return parseFloat(value).toLocaleString(defaultLocale_, { options })
  }
}
export async function generateKey() {
    const cryptoKey = await window.crypto.subtle.generateKey(
        {
            name: "AES-GCM",
            length: 256,
        },
        true,
        ["encrypt", "decrypt"]
    );
    const iv = window.crypto.getRandomValues(new Uint8Array(12));
    return { cryptoKey, iv };
}

export async function encryptString(message, key) {
    const encoder = new TextEncoder();
    const data = encoder.encode(message);
    const encryptedData = await window.crypto.subtle.encrypt(
        {
            name: "AES-GCM",
            iv: key.iv,
        },
        key.cryptoKey,
        data
    );
    return { encryptedData, iv: key.iv };
}

export async function decryptString(encryptedData, key) {
    const decryptedData = await window.crypto.subtle.decrypt(
        {
            name: "AES-GCM",
            iv: key.iv,
        },
        key.cryptoKey,
        encryptedData
    );
    const decoder = new TextDecoder();
    return decoder.decode(decryptedData);
}
